import { AccountCategory } from '../enums/management-input.enum.ts'
import { DefaultOptionType } from 'antd/es/select/index'

const baseCategories = [
  AccountCategory.Global,
  AccountCategory.Japan,
  AccountCategory.GreaterChinaLowNet,
  AccountCategory.GreaterChinaLongBias,
  AccountCategory.India,
  AccountCategory.Korea,
  AccountCategory.Australia,
]

export const getCategoryOptions = (t: (key: string) => string) => [
  { value: '', label: t('common.user_controls.all_categories') },
  ...baseCategories.map((cat) => ({ value: cat, label: cat })),
]

export const getRankingCategoryOptions = (t: (key: string) => string) => [
  { value: 'All', label: t('common.user_controls.all_categories') },
  ...baseCategories.map((cat) => ({ value: cat, label: cat })),
]

export const regionOptions = [
  { value: 'Japan', label: 'Japan' },
  { value: 'Greater China', label: 'Greater China' },
  { value: 'India', label: 'India' },
  { value: 'Korea', label: 'Korea' },
  { value: 'Australia', label: 'Australia' },
]

const NET_CATEGORY_MAP = new Map([
  ['Global', [{ value: 'Global', label: 'Global' } as DefaultOptionType]],
  ['Japan', [{ value: 'Japan', label: 'Japan' } as DefaultOptionType]],
  [
    'Greater China',
    [
      { value: 'Long Bias', label: 'Long Bias' } as DefaultOptionType,
      { value: 'Low Net', label: 'Low Net' } as DefaultOptionType,
    ],
  ],
  ['India', [{ value: 'India', label: 'India' } as DefaultOptionType]],
  ['Korea', [{ value: 'Korea', label: 'Korea' } as DefaultOptionType]],
  [
    'Australia',
    [{ value: 'Australia', label: 'Australia' } as DefaultOptionType],
  ],
])

export function getNetCategories(region: string): DefaultOptionType[] {
  return NET_CATEGORY_MAP.get(region) ?? []
}

export interface SplitCategory {
  region: string
  netCategory: string
}

/**
 * Split a combined category option value into backend region / netCategory params.
 * Inverse of getMatchedCombinedCategory.
 *   ''  | 'All'                    -> { region: '', netCategory: '' }
 *   'Japan'                        -> { region: 'Japan', netCategory: '' }
 *   'Greater China - Low Net'      -> { region: 'Greater China', netCategory: 'Low Net' }
 */
export function splitCategory(category?: string | null): SplitCategory {
  if (!category || category === 'All') return { region: '', netCategory: '' }
  const [region = '', netCategory = ''] = category
    .split('-')
    .map((s) => s.trim())
  return { region, netCategory }
}

export function getMatchedCombinedCategory(
  region: string,
  netCategory: string,
  t: (key: string) => string
): string | undefined {
  let combinedCategory = region
  if (region === 'Greater China' && netCategory) {
    combinedCategory = `${region} - ${netCategory}`
  }
  const categoryOptions = getCategoryOptions(t)
  const match = categoryOptions.find((opt) => opt.value === combinedCategory)
  return match ? combinedCategory : undefined
}
